module.exports = __webpack_public_path__ + "img/Website Header 1.d579aaa5.png";